import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { IClientApplicationView, ITalentApplicationView } from '../../Types/Application';
import { FallbackEmailRequest } from '../../Types/General';
import { AppSettings } from '../../Utils/Settings';
export const adminApi = createApi({
    reducerPath: 'adminApi',
    baseQuery: fetchBaseQuery({
        baseUrl: AppSettings.ApiBaseUrl,
        // prepareHeaders: async (headers, {getState}) =>{
        //     headers.set(
        //         'Authorization',
        //         `Bearer ${(localStorage.getItem('token') ?? '')}`
        //     );
        //     return headers;
        // }
    }),
    endpoints: (builder) => ({     
        getAdminCredentials: builder.mutation<{success: boolean, token: string}, {user_login: string, password: string}>({
            query: (body) => ({
                url: `/admin/login`,
                method: "POST",
                body
            })
        }),       
        resetPassword: builder.mutation<any, {locator: string, token: string, password: string}>({
            query: (params) => ({
                url: `/password-reset/${params.locator}/${params.token}`,
                method: "POST",
                body: {password: params.password}
            })
        }),       
        sendFallbackEmail: builder.mutation<any, FallbackEmailRequest>({
            query: (body) => ({
                url: `/admin/fallback-email`,
                method: "POST",
                body
            })
        }), 
    }),
})

export const {
    useGetAdminCredentialsMutation,
    useResetPasswordMutation,
    useSendFallbackEmailMutation
} = adminApi
